export default __webpack_public_path__ + "static/media/404.6ccd9742.svg";